import { render, staticRenderFns } from "./Headquarter.vue?vue&type=template&id=49684e4e&"
import script from "./Headquarter.vue?vue&type=script&lang=ts&"
export * from "./Headquarter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports